import React from "react";

export const Eyebrow = ({ children, tone = "gold", className = "", ...rest }) => {
  const color =
    tone === "gold"
      ? "text-gold"
      : tone === "muted"
        ? "text-[var(--q-text-muted)]"
        : "text-[var(--q-text)]";
  return (
    <span
      className={`inline-flex items-center gap-2 font-sans uppercase tracking-eyebrow text-[11px] sm:text-xs font-medium ${color} ${className}`}
      {...rest}
    >
      <span
        aria-hidden="true"
        className="inline-block h-px w-6 bg-gold"
      />
      <span>{children}</span>
    </span>
  );
};

export default Eyebrow;
